import * as React from 'react';

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>> {
    state = { error: null }

    static getDerivedStateFromError(error) {
        return { error: error.message }
    }

    componentDidCatch(error) {
        console.error(error)
        this.setState({ error: error.message })
    }

    render() {
        if (this.state.error) {
            return (
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
                    </svg>
                    <div className="px-2">
                        <h3 className="mb-0">
                            Error
                        </h3>
                        <p className="mb-0">
                            An error occured within this Zen AutoArt control. Please raise a HelpDesk ticket detailing what you were doing when this error occurred and the following error message:
                        </p>
                        <code>{this.state.error}</code>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}